<template>
  <form ref="editarForm" @submit.prevent="submitEditForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="cliente" v-model="dado.cliente_exibicao" size="small" style="width: 100%" disabled/>
            <label for="cliente"><strong>Cliente: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="imovel" v-model="dado.imovel_exibicao" size="small" style="width: 100%" disabled/>
            <label for="imovel"><strong>Imóvel: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="corretor" v-model="dado.corretor_exibicao" size="small" style="width: 100%" disabled/>
            <label for="corretor"><strong>Corretor: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <Select
                v-model="dado.tipo_imovel"
                inputId="tipo_imovel"
                :options="tipoImovel"
                optionLabel="label"
                optionValue="value"
                size="small"
                appendTo="body"
                style="width: 100%"
                disabled
            />
            <label for="tipo_imovel"><strong>Tipo Imóvel: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor" v-model="dado.valor" size="small" style="width: 100%" disabled
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="valor"><strong>Valor do Imóvel: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="analista" v-model="dado.analista" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('analista')" autofocus/>
            <label for="analista"><strong>Análista: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputNumber id="valor_financiamento" v-model="dado.valor_financiamento" size="small"
                         style="width: 100%"
                         :invalid="campoVazio.includes('valor_financiamento')"
                         :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
            <label for="valor_financiamento">
              <strong>Valor do Financiamento: <span class="text-danger font-bold">*</span></strong>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <FloatLabel variant="on">
            <DatePicker id="data_avaliacao" v-model="dado.data_avaliacao" showIcon iconDisplay="input"
                        size="small" style="width: 100%" appendTo="body" ref="dataAvaliacao" dateFormat="dd/mm/yyyy"/>
            <label for="data_avaliacao"><strong>Data Avaliação: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="observacao" v-model="dado.observacao" rows="2" cols="45"/>
            <label for="observacao"><strong>Observação: </strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="descritivo" v-model="dado.descritivo" rows="4" cols="45" disabled/>
            <label for="descritivo"><strong>Descritivo: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <hr>
    <div class="float-right">
      <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
    </div>
    <button class="btn btn-danger font-bold" @click="$emit('fechar')">
      Cancelar
    </button>
  </form>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates, formatarMoeda, normalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"


export default {
  name: "EditarAnalise",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  emits: ['fechar', 'atualizarDados'],
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
      tipoImovel: [
        {label: 'CONSTRUIDO', value: 'C'},
        {label: 'NA PLANTA', value: 'N'}
      ],
    }
  },
  methods: {
    async getAnalise() {
      const resultado = await apiRequest("GET", `${apiUrl.analises.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        normalizeDates(this.dado, ['data_avaliacao']);
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_avaliacao']);
      const resultado = await apiRequest("PATCH", `${apiUrl.analises.retrieveUpdateDestroy(this.itemKey)}?modo=edit`, this.dado);
      if (resultado.success) {
        const dadoAtualizado = {
          id: this.dado.id,
          valor: formatarMoeda(this.dado.valor),
          observacao: this.dado.observacao,
          analista: this.dado.analista,
        };
        this.$emit("atualizarDados", dadoAtualizado);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar')
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getAnalise();
    Inputmask("99/99/9999").mask(this.$refs.dataAvaliacao.$el.querySelector("input"));
  },
}
</script>
